import { redirect } from "@tanstack/react-router";

import type { Permission } from "~/types/auth.type";

export type PagePermissionKey = keyof NonNullable<Permission["page"]>;

export const requirePagePermission = (
  permissions: Permission | undefined,
  pagePermission: PagePermissionKey,
  buildingId: string,
  preload?: boolean,
) => {
  if (!preload && !permissions?.page?.[pagePermission]) {
    throw redirect({ to: "/buildings/$buildingId/dashboard", params: { buildingId } });
  }
};
